import {Injectable} from "@angular/core";
import {
  IssueResourceSelectorKind, IssueType,
  PrioritySimpleDto,
  ResourceProfileDto,
  StereotypeUsageDto,
  SubmitTicketIssueDto,
  TicketIssueDto,
  TicketIssuePreviewDto
} from "@server-models";
import {FormGroup} from "@angular/forms";
import {
  SharedIssueStereotypeBaseService
} from "@shared/components/issues/services/stereotype/shared-issue-stereotype-base.service";
import {TCurrentIssueDto} from "@shared/components/issues/types/issue-dto.type";
import {ILocalIssueDetailData} from "@shared/components/issues/interfaces/local-issue-detail-data.interface";
import {IAdditionalDetails} from "@shared/components/issues/interfaces/additional-details.interface";

@Injectable({
  providedIn: 'root',
})
export class SharedIssueTicketService extends SharedIssueStereotypeBaseService {

  override formatReadDetailData(issueDtoType: TCurrentIssueDto, issueType: IssueType): ILocalIssueDetailData {
    const issueDtoTypeTicket = issueDtoType as TicketIssueDto;
    return {
      ...this.formatBaseReadDetailData(issueDtoTypeTicket, issueType),
      additionalDetails: {...this.getAdditionalFormattedData(issueDtoTypeTicket)}
    };
  }

  prepareFormIssueDto(formGroup: FormGroup, templatePreviewDto: TicketIssuePreviewDto,
                      resourceDto?: ResourceProfileDto): SubmitTicketIssueDto {
    const priorityFormGroup = formGroup.get('Priority') as FormGroup;
    const contactFormGroup = formGroup.get('Contact') as FormGroup;
    const resourceFromGroup = formGroup.get('Resource') as FormGroup;

    const resource = resourceFromGroup?.value ? resourceFromGroup?.value : resourceDto;
    const resourceKind = this._isResourceSelectorKindSelection(templatePreviewDto.resourceSelectorKind!) ? resource : undefined;

    const priority = priorityFormGroup ? this.findPriorityValue(priorityFormGroup, templatePreviewDto.priorities!) : templatePreviewDto.priorities?.[0];
    const editor = contactFormGroup.value ? contactFormGroup.value : templatePreviewDto.contacts?.[0];

    const issueStereotype: StereotypeUsageDto = templatePreviewDto.issueStereotype!;
    const customPropertyValues = this.getCustomPropertyValues(formGroup);


    return {
      title: templatePreviewDto.name,
      tenantId: issueStereotype?.tenantId,
      stereotypeId: issueStereotype?.stereotypeId,
      stereotypeRowVersion: issueStereotype?.rowVersion,
      customPropertyValues,
      priority,
      resource: resourceKind,
      ...(editor && { editor })
    };
  }

  _isResourceSelectorKindSelection(resourceOption: IssueResourceSelectorKind): boolean {
    let displayResource = true;
    if (resourceOption === IssueResourceSelectorKind.Selection) {
      displayResource = true;
    } else if (resourceOption === IssueResourceSelectorKind.None) {
      displayResource = false;
    }
    return displayResource;
  }

  findPriorityValue(priorityForm: FormGroup, priorities: PrioritySimpleDto[]): PrioritySimpleDto {
    const valueToFind = priorityForm.value;
    return priorities.find(p => p?.priorityId === valueToFind)!;
  }

  getAdditionalFormattedData(issueDto: TicketIssueDto): Partial<IAdditionalDetails> {
    const ticketDetail = issueDto.ticket;
    const resourceDetail = issueDto.resource;
    const editorDetail = issueDto.editor;
    return {
      ticket: ticketDetail,
      editor: editorDetail,
      resource: resourceDetail
    };
  }
}
